import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { LinearProgress, Typography, Box } from '@material-ui/core';


const LinearProgressWithLabel = (props) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" width="100%">
      <Box width="90%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

export default LinearProgressWithLabel;
